<template>
<div>
  <div class="row">
    <p>Get quality leads and interact directly with customers. Simply set a budget, create a coupon and publish it to your profile. Customers start a chat directly with you and you get contact information and a great lead.</p>
    <p>Pricing: $10 per click</p>
    <p>If you set your budget, you will never be billed more than the alloted amount per month. Billing is done in arrears on a monthly basis. No refunds. If you have an issue with billing, please contact HomApt Marketplace Support at support@homapt.com or (612) 655-2324.</p>
  </div>
  <div class="row">
    <div class="jumbotron col-5">
      <h3>Discounted Price</h3>
      <p class="d-block">
        Want to offer a discount on your services to get potential customers? Use this wizard to start a coupon offering a percent discount on services. Example: $75 for $100 of Lawn Service. This means you will offer a $25 discount on services rendered.
      </p>
      <router-link
        tag="button"
        v-on:click.native="updateCouponCategory('Discounted Price')"
        class="btn btn-primary select-button"
        to="/profile/business/advertising/coupons/details"
      >Select</router-link>
    </div>
    <div class="jumbotron col-5 offset-1">
      <h3>Discounted Service</h3>
      <p class="d-block">
        Want to offer a free service? Use this wizard to start a coupon offering of a specific service. Example: Free Water Heater Inspection with purchase of Furnace Tune Up. This means you will offer a "free" or discounted service included with the purchase of another service.
      </p>
      <router-link
        tag="button"
        v-on:click.native="updateCouponCategory('Discounted Service')"
        class="btn btn-primary select-button"
        to="/profile/business/advertising/coupons/details"
      >Select</router-link>
    </div>
  </div>
</div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  methods: {
    ...mapMutations('products', [
      'updateCouponCategory'
    ])
  }
}
</script>

<style scoped>
.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.select-button {
  display: block;
  margin: 0 auto;
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/advertising/coupons/subnavItems/Overview.vue